export const configuration = {
	installerURL: 'https://static.zesty.co/ZX-InfraStructure-Agent-release/install.sh',
	azureBucketURL: 'https://static.zesty.co/azure-onboarding.sh',
	apiUrl: 'https://api.cloudvisor.io',
	featureFlagEnvKey: {
		launchDarklyKey: '641c252a9e7832134cc4bf46',
	},
	remotes: {
		headerUrl: '/header/:version',
		azureVmUrl: '/azure-vm/:version',
		commitmentManagerUrl: '/commitment-manager/:version',
		sidebarUrl: '/sidebar/:version',
		insightsUrl: '/insights/:version',
		kompassUrl: '/kompass/:version',
		organizationSettingsUrl: '/organization-settings/:version',
		partnerPortalUrl: '/partner-portal/:version',
		ec2ListingsUrl: '/ri-manager/:version',
		zestyDiskDashboardUrl: '/zesty-disk-dashboard/:version',
	},
	mixpanel: '046606aeaa32f0437b117f592e50db3b',
	coralogixPublicKey: 'cxtp_gGBv0fBAXy7rlk0VgS76QVz4FVy4kA',
};
